<template>
  <div>
    <div class="up-input-group">
      <up-numberinput
        v-model="shapes.num_cols"
        size="sm"
        label="No. of cols"
        labelIcon="mdi mdi-dots-horizontal"
      ></up-numberinput>
      <up-numberinput
        v-model="shapes.num_rows"
        size="sm"
        label="No. of rows"
        labelIcon="mdi mdi-dots-vertical"
      ></up-numberinput>
      <up-numberinput
        v-model="shapes.margin_percent"
        size="sm"
        label="Margin Percent"
        labelIcon="mdi mdi-stretch-to-page-outline"
      ></up-numberinput>
      <up-switch
        v-model="shapes.is_selectable"
        size="sm"
        label="Is Selectable"
        labelIcon="mdi mdi-alpha-s-box-outline"
      >
      </up-switch>
    </div>
    <div class="column is-9 is-flex is-justify-content-space-between">
      <style-editor
        v-model="shapes.styles"
        show_width
        show_height
        show_bg_color
      ></style-editor>
      <style-editor
        title="Point"
        v-model="shapes.point_styles"
        show_width
        show_bg_color
      ></style-editor>
      <style-editor
        title="Line"
        v-model="shapes.line_styles"
        show_width
        show_border_color
      ></style-editor>
    </div>

    <!--Inputs-->
    <div class="column is-6">
      <p class="title is-5">
        Inputs
        <b-button
          @click="addInputRow"
          type="is-success"
          size="is-small"
          icon-left="plus"
        ></b-button>
      </p>
      <b-table v-if="shapes.inputs" :data="shapes.inputs">
        <b-table-column field="text" label="Row" v-slot="props">
          <up-textinput v-model="props.row.text"></up-textinput>
        </b-table-column>
        <b-table-column field="action" label="Action" v-slot="props">
          <b-button
            @click="removeInputRow(props.index)"
            size="is-small"
            type="is-danger"
            icon-left="close"
          ></b-button>
        </b-table-column>
      </b-table>
    </div>
    <div class="column is-6">
      <p class="title is-5">
        Angles
        <b-button
          @click="addAngleRow()"
          type="is-success"
          size="is-small"
          icon-left="plus"
        ></b-button>
      </p>
      <b-table v-if="shapes.angles" :data="shapes.angles">
        <b-table-column field="dot_row" label="Row Index" v-slot="props">
          <up-numberinput v-model="props.row.dot_row"></up-numberinput>
        </b-table-column>
        <b-table-column field="dot_col" label="Column Index" v-slot="props">
          <up-numberinput v-model="props.row.dot_col"></up-numberinput>
        </b-table-column>
        <b-table-column field="angle_type" label="Angle Type" v-slot="props">
          <up-select v-model="props.row.angle_type">
            <option value="A">Acute</option>
            <option value="O">Obtuse</option>
          </up-select>
        </b-table-column>
        <b-table-column field="arc_width" label="Arc Width" v-slot="props">
          <up-numberinput v-model="props.row.arc_width"></up-numberinput>
        </b-table-column>
        <b-table-column field="action" label="Action" v-slot="props">
          <b-button
            @click="removeAngleRow(props.index)"
            size="is-small"
            type="is-danger"
            icon-left="close"
          ></b-button>
        </b-table-column>
      </b-table>
    </div>
    <div class="columns">
      <div class="column is-flex">
        <show-shapes
          is_input_draggable
          :is_selectable="shapes.is_selectable"
          :shapes="shapes"
          @receiveLines="receiveLines"
        ></show-shapes>
      </div>
    </div>
  </div>
</template>

<script>
import ShowShapes from "./ShowShapes.vue";
import {
  defaultShapesValue,
  defaultInputRowValue,
  defaultAngleRowValue,
} from "./utils";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";

import UpSelect from "@/components/UI/Inputs/UpSelect";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";
export default {
  name: "set-shapes",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowShapes,
    UpNumberinput,
    UpTextinput,
    StyleEditor,
    UpSwitch,
    UpSelect,
  },
  data() {
    return {
      is_drawing: false,
      shapes: this.value ? this.value : defaultShapesValue(),
    };
  },
  methods: {
    addInputRow() {
      this.shapes.inputs.push(defaultInputRowValue());
    },
    removeInputRow(index) {
      this.shapes.inputs.splice(index, 1);
    },
    addAngleRow() {
      this.shapes.angles.push(defaultAngleRowValue());
    },
    removeAngleRow(index) {
      this.shapes.angles.splice(index, 1);
    },
    receiveLines(lines) {
      this.shapes.lines = lines;
    },
  },
  watch: {
    value: {
      handler: function (new_val) {
        this.shapes = new_val;
      },
      deep: true,
    },
    shapes: {
      handler: function (new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
